var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 48,
    viewBox: "0 0 542 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.349 47.554V15.6856H523.483V42.087H541.462V47.554H517.349Z",
    fill: "#18191B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.682 31.6198C480.593 21.5748 487.082 15.13 496.149 15.2412C505.216 15.13 511.75 21.5748 511.639 31.6198C511.75 41.6648 505.216 48.1096 496.149 47.9985C487.082 48.1096 480.593 41.6648 480.682 31.6198ZM495.927 42.5537H496.394C502.061 42.5537 505.483 38.4202 505.483 31.6198C505.483 24.7972 502.061 20.7081 496.394 20.7081H495.927C490.26 20.7081 486.838 24.7972 486.838 31.6198C486.838 38.4202 490.26 42.5537 495.927 42.5537Z",
    fill: "#18191B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M445.79 31.6198C445.701 21.5748 452.19 15.13 461.257 15.2412C470.324 15.13 476.858 21.5748 476.747 31.6198C476.858 41.6648 470.324 48.1096 461.257 47.9985C452.19 48.1096 445.701 41.6648 445.79 31.6198ZM461.035 42.5537H461.501C467.168 42.5537 470.591 38.4202 470.591 31.6198C470.591 24.7972 467.168 20.7081 461.501 20.7081H461.035C455.368 20.7081 451.945 24.7972 451.945 31.6198C451.945 38.4202 455.368 42.5537 461.035 42.5537Z",
    fill: "#18191B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M427.211 47.554V21.1526H416.211V15.6856H444.434V21.1526H433.367V47.554H427.211Z",
    fill: "#18191B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M379.609 47.554V15.6856H403.721V21.1526H385.742V28.4863H400.988V33.9533H385.742V42.087H404.188V47.554H379.609Z",
    fill: "#18191B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M345.518 31.6198C345.451 21.8415 351.163 15.1523 360.763 15.2412C368.919 15.1523 373.764 20.0859 374.142 26.1529H368.008C367.319 22.686 364.83 20.7081 360.986 20.7081H360.541C355.319 20.6414 351.607 24.9083 351.674 31.6198C351.674 38.3535 355.274 42.5537 360.541 42.5537H360.986C364.875 42.5537 367.319 40.6425 368.008 37.0868H374.142C373.742 43.3982 368.964 48.0651 360.763 47.9985C351.163 48.0874 345.451 41.3981 345.518 31.6198Z",
    fill: "#18191B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.65 15.6857H339.784V47.554H331.828L319.294 24.0861V47.554H313.16V15.6857H321.116L333.65 39.0425V15.6857Z",
    fill: "#18191B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M302.649 47.554L299.782 40.0425H286.404L283.537 47.554H277.07L289.671 15.6856H296.871L309.161 47.554H302.649ZM288.471 34.5755H297.693L293.071 22.486L288.471 34.5755Z",
    fill: "#18191B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.114 47.554V15.6857H273.248V47.554H267.114Z",
    fill: "#18191B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M238.445 47.554V15.6857H244.578V42.0871H262.557V47.554H238.445Z",
    fill: "#18191B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M208.756 47.554V15.6857H223.09C229.29 15.6857 233.335 19.397 233.335 25.7084C233.335 32.0199 229.29 35.7756 223.09 35.7756H214.889V47.554H208.756ZM214.889 30.3087H222.401C225.512 30.3087 227.179 28.5308 227.179 25.7084C227.179 22.8861 225.512 21.1526 222.401 21.1526H214.889V30.3087Z",
    fill: "#18191B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191.755 15.6857H201.267V47.554H195.244V22.486L187.333 47.554H180.599L172.443 22.3971V47.554H166.443V15.6857H175.999L183.999 40.687L191.755 15.6857Z",
    fill: "#18191B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.773 31.6198C129.684 21.5748 136.173 15.13 145.241 15.2412C154.308 15.13 160.841 21.5748 160.73 31.6198C160.841 41.6648 154.308 48.1096 145.241 47.9985C136.173 48.1096 129.684 41.6648 129.773 31.6198ZM145.018 42.5537H145.485C151.152 42.5537 154.574 38.4202 154.574 31.6198C154.574 24.7972 151.152 20.7081 145.485 20.7081H145.018C139.351 20.7081 135.929 24.7972 135.929 31.6198C135.929 38.4202 139.351 42.5537 145.018 42.5537Z",
    fill: "#18191B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4603 31.6198C97.3936 21.8415 103.105 15.1523 112.706 15.2412C120.862 15.1523 125.706 20.0859 126.084 26.1529H119.95C119.261 22.686 116.772 20.7081 112.928 20.7081H112.483C107.261 20.6414 103.55 24.9083 103.616 31.6198C103.616 38.3535 107.216 42.5537 112.483 42.5537H112.928C116.817 42.5537 119.261 40.6425 119.95 37.0868H126.084C125.684 43.3982 120.906 48.0651 112.706 47.9985C103.105 48.0874 97.3936 41.3981 97.4603 31.6198Z",
    fill: "#18191B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.5494C0 17.0858 1.18642 15.8994 2.64994 15.8994H29.1493C30.6128 15.8994 31.7993 17.0858 31.7993 18.5494V45.049C31.7993 46.5125 30.6128 47.6989 29.1493 47.6989H2.64994C1.18642 47.6989 0 46.5125 0 45.049V18.5494Z",
    fill: "url(#paint0_linear_20850_8281)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85 2.64996C23.85 1.18643 25.0364 0 26.4999 0H68.8989C70.3624 0 71.5489 1.18643 71.5489 2.64996V45.0493C71.5489 46.5129 70.3624 47.6993 68.8989 47.6993H26.4999C25.0364 47.6993 23.85 46.5129 23.85 45.0493V2.64996Z",
    fill: "url(#paint1_radial_20850_8281)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.024 17.2245H71.5485V13.2495H47.699C46.2355 13.2495 45.0491 14.4359 45.0491 15.8995V30.4743H23.8496V34.4492H46.374C47.8376 34.4492 49.024 33.2628 49.024 31.7992V17.2245Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1797 47.6988H26.4999C25.0364 47.6988 23.85 46.5124 23.85 45.0488V15.8994H29.1496C30.6132 15.8994 31.7996 17.0858 31.7996 18.5494V45.049C31.7996 46.5025 30.6294 47.6827 29.1797 47.6988Z",
    fill: "url(#paint2_linear_20850_8281)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7998 34.4496H23.85V30.4746H31.7998C31.7998 30.4746 31.7998 31.661 31.7998 33.1246V34.4496Z",
    fill: "#00F9F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20850_8281",
    x1: 15.8996,
    y1: 15.8994,
    x2: 15.8996,
    y2: 47.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20850_8281",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.85 47.6993) rotate(-45.0002) scale(67.4567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0037DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20850_8281",
    x1: 47.6988,
    y1: 15.8994,
    x2: 47.6988,
    y2: 47.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ffc83943af3c6b4abc8bc3aae3507235.svg";
export { ForwardRef as ReactComponent };